import React, { FC } from "react";
import CloseIcon from "@material-ui/icons/Close";
import TenpoCheckManagerAnalysisOKNGButton from "./TenpoCheckManagerAnalysisOKNGButton";

const TenpoCheckManagerAnalysisNgButton: FC<{
  id: string;
  bigItemId: string;
  smallItemId: string;
  selectedTemplateItemName?: string;
  selectedTemplateItemUuid?: string;
}> = ({ id, bigItemId, smallItemId, selectedTemplateItemName ,selectedTemplateItemUuid}) => {
  return (
    <>
      <TenpoCheckManagerAnalysisOKNGButton
        id={id}
        bigItemId={bigItemId}
        smallItemId={smallItemId}
        selectedTemplateItemName={selectedTemplateItemName}
        selectedTemplateItemUuid={selectedTemplateItemUuid}
        icon={<CloseIcon style={{ fontSize: "16px" }} />}
      />
    </>
  );
};
export default TenpoCheckManagerAnalysisNgButton;
